'use strict';

/**
 * Fetches the balance for the given subscription id. And braodcast it so that all data are synced on the app.
 */
customerZone.service('BalanceService', ['$rootScope', '$q', '$log',  'UnleashedClient', 'Session',
    'errorCode', function($rootScope, $q, $log, api, Session, errorCode){

        var self = this;

        self.balance = {loading: true};

        self.balance.credit = undefined;

        self.unavailableBalance = false;

        self.refresh = function(){
            return fetchBalance()
                .then(setBalance)
                .catch(function(error){
                    $log.error('Failed to load balance: ', error);
                    if (self.balance.loading)
                        setBalance({error: true});
                });
        };

        var setBalance = function(value){
            self.balance = value;
            $rootScope.$broadcast('balanceRefreshed', self.balance);
        };

        /**
         * Fetch the balance from UWA, unless the subscription is not in a state to do so.
         */
        var fetchBalance = function(){

            var subscriber = Session.subscriber();
            if (!subscriber) return $q.when({});
            if (!subscriber.sim) return $q.when({});
            if (subscriber.state === jim.SubscriberState.disabled) return $q.when({});
            if (subscriber.state === jim.SubscriberState.pending) return $q.when({});
            if (Session.flags('postpaid_on_transatel')) return $q.when({});

            return api.getBalance(subscriber.id)
                .then(function(balance){

                    var bingeCredit = undefined;
                    var extractBingeCredit = function(bundles){
                        if (!subscriber.isPostpaid()) return bundles;
                        var bingeBundle;
                        for (var i = 0; !bingeBundle && (i < bundles.length); i++){
                            var bundle = bundles[i];
                            if ( bundle.type === 'value')
                                bingeBundle = bundle;
                        }
                        if (bingeBundle) {
                            bingeCredit = bingeBundle.remainingAmount;
                            return bundles.filter(function(b){ return b.type !== 'value'; });
                        }
                        return bundles;
                    };

                    var bundles = balance.bundles || [];
                    bundles = extractBingeCredit(bundles);

                    return {
                        credit: balance.credit,
                        bingeCredit: bingeCredit,
                        outOfBundle: balance.outOfBundle || 0,
                        bundles: bundles
                    };
                }).catch(function(error){
                    if (errorCode.is(error, errorCode.BAD_GATEWAY)){
                        return {credit: 'unavailable'};
                    }
                    else if (errorCode.is(error, errorCode.SUBSCRIPTION_DEACTIVATED)){
                        $log.warn('Attempted to get balance for an inactive subscription');
                        return {};
                    }
                    throw error;
                });
        };

        self.getBalance = function(){
            return self.balance;
        };

        $rootScope.$on(Session.SUBSCRIPTION_CHANGED_EVENT, function(){
            $log.debug('subscription changed - updating balance');
            setBalance({loading: true});
            self.refresh();
        });

    }]);
